import { render, staticRenderFns } from "./PlacesSettings.vue?vue&type=template&id=785793f8"
import script from "./PlacesSettings.vue?vue&type=script&lang=js"
export * from "./PlacesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports